import React from "react";
import { toast } from "react-toastify";
import { CheckCircle, AlertCircle, Info } from "lucide-react";

const toastVariants = {
  success: {
    title: "Succès",
    icon: CheckCircle,
    iconClass: (isDark) =>
      isDark
        ? "bg-emerald-500/15 text-emerald-300"
        : "bg-emerald-50 text-emerald-600",
  },
  error: {
    title: "Erreur",
    icon: AlertCircle,
    iconClass: (isDark) =>
      isDark ? "bg-rose-500/15 text-rose-300" : "bg-rose-50 text-rose-600",
  },
  info: {
    title: "Information",
    icon: Info,
    iconClass: (isDark) =>
      isDark ? "bg-blue-500/15 text-blue-200" : "bg-blue-50 text-blue-600",
  },
};

const isDarkTheme = () => {
  if (typeof document === "undefined") {
    return true;
  }
  return document.documentElement.classList.contains("dark");
};

export const showToast = (type, message, options = {}) => {
  const variant = toastVariants[type] || toastVariants.info;
  const Icon = variant.icon;
  const darkMode = isDarkTheme();
  const baseTextClass = darkMode ? "text-white" : "text-slate-900";
  const secondaryTextClass = darkMode ? "text-white/70" : "text-slate-500";
  const containerClass = darkMode
    ? "bg-slate-950/95 text-white border border-white/10"
    : "bg-white text-slate-900 border border-slate-200";
  const shadowClass = darkMode
    ? "shadow-2xl shadow-black/40"
    : "shadow-xl shadow-slate-200";

  toast(
    <div className="flex items-start gap-3">
      <div
        className={`w-10 h-10 rounded-2xl flex items-center justify-center ${variant.iconClass(
          darkMode,
        )}`}
      >
        <Icon className="w-5 h-5" />
      </div>
      <div className={`text-sm ${baseTextClass}`}>
        <p className={`font-semibold leading-tight ${baseTextClass}`}>
          {variant.title}
        </p>
        <p className={`${secondaryTextClass} leading-tight`}>{message}</p>
      </div>
    </div>,
    {
      icon: false,
      className: `${containerClass} rounded-2xl ${shadowClass} backdrop-blur-lg px-4 py-3`,
      bodyClassName: "!m-0 !p-0",
      progressClassName: darkMode ? "bg-white/30" : "bg-slate-900/30",
      theme: darkMode ? "dark" : "light",
      ...options,
    },
  );
};
